// src/reducers/userReducer.js
import {
    GET_SIGNUP_SUCCESS,
    GET_SIGNUP_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const signupReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SIGNUP_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_SIGNUP_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  